export const oceanGuideDirectoryLinks = [
  ["/ocean-guide", "宮古島の今日の海況"],
  ["/ocean-guide/snorkeling-today", "宮古島の今日のシュノーケル情報"],
  ["/ocean-guide/tomorrow-weather", "宮古島の明日の海況"],
  ["/ocean-guide/windy-day-beaches", "宮古島の風向きに合うビーチ"],
  ["/ocean-guide/after-typhoon-sea", "宮古島の波・うねり・台風情報"],
  ["/ocean-guide/sunset-today", "今日のサンセット"],
  ["/ocean-guide/stargazing-tonight", "今夜の星空"],
  ["/ocean-guide/spots", "ビーチ・観光スポット一覧"],
  ["/ocean-guide/restaurants", "飲食店・カフェ一覧"],
  ["/ocean-guide/hotels", "ホテル・ヴィラを探す"],
];

export const oceanSearchGuideLinks = [
  ["/ocean-guide", "宮古島の今日の海況"],
  ["/ocean-guide/beach", "宮古島で今日行く海を選ぶ"],
  ["/ocean-guide/snorkeling-today", "宮古島のシュノーケル情報を今日の予報から確認"],
  ["/ocean-guide/tomorrow-weather", "宮古島の明日の海況・波予報"],
  ["/ocean-guide/windy-day-beaches", "宮古島の風向きに合うビーチ"],
  ["/ocean-guide/after-typhoon-sea", "宮古島の波・うねり・台風情報"],
];

const clusterLinks = {
  hotel: [
    ["/ocean-guide/hotels", "エリア・予算からホテルを探す"],
    ["/itinerary", "宮古島の旅程をつくる"],
  ],
  stars: [
    ["/ocean-guide/stargazing", "宮古島の星空ガイド"],
    ["/ocean-guide/stargazing-tonight", "今夜の星空予報"],
    ["/ocean-guide/spots", "星空・観光スポットを探す"],
  ],
  sunset: [
    ["/ocean-guide/sunset", "宮古島のサンセットガイド"],
    ["/ocean-guide/sunset-today", "今日のサンセット予報"],
    ["/ocean-guide/spots", "サンセットスポットを探す"],
  ],
  beach: [
    ["/ocean-guide", "宮古島の今日の海況を確認する"],
    ["/ocean-guide/beach", "宮古島のビーチガイド"],
    ["/ocean-guide/windy-day-beaches", "宮古島の風向きに合うビーチ"],
    ["/ocean-guide/spots", "ビーチ・観光スポット一覧"],
  ],
  rain: [
    ["/ocean-guide/rainy-day", "今日の雨と雨の日の過ごし方"],
    ["/ocean-guide/restaurants", "カフェ・飲食店を探す"],
  ],
  food: [
    ["/ocean-guide", "宮古島の今日の海・海況を確認する"],
    ["/ocean-guide/restaurants", "営業時間・予算から飲食店を探す"],
    ["/ocean-guide/rainy-day", "雨の日の過ごし方"],
  ],
  itinerary: [
    ["/itinerary", "宮古島の旅程をつくる"],
    ["/ocean-guide", "今日の天気・海況を確認する"],
    ["/ocean-guide/hotels", "ホテル・ヴィラを探す"],
  ],
};

export const getBlogGuideLinks = (slug = "") => {
  if (/hotel/.test(slug)) return clusterLinks.hotel;
  if (/starry|full-moon/.test(slug)) return clusterLinks.stars;
  if (/sunset/.test(slug)) return clusterLinks.sunset;
  if (/beach|surfing|yabiji|secret/.test(slug)) return clusterLinks.beach;
  if (/rainy/.test(slug)) return clusterLinks.rain;
  if (/cafe|lunch|soba|sata-andagi|dinner|yakiniku|sweets|gelato/.test(slug)) return clusterLinks.food;
  if (/model-course|without-car|travel-dashboard/.test(slug)) return clusterLinks.itinerary;
  return [
    ["/ocean-guide", "宮古島の今日の海況を確認する"],
    ["/ocean-guide/tomorrow-weather", "宮古島の明日の海況を確認する"],
    ["/ocean-guide/spots", "ビーチ・観光スポットを探す"],
  ];
};

export const oceanLandingPaths = new Set([
  "/ocean-guide/snorkeling",
  "/ocean-guide/beach",
  "/ocean-guide/stargazing",
  "/ocean-guide/sunset",
  "/ocean-guide/snorkeling-today",
  "/ocean-guide/windy-day-beaches",
  "/ocean-guide/rainy-day",
  "/ocean-guide/tomorrow-weather",
  "/ocean-guide/sunset-today",
  "/ocean-guide/stargazing-tonight",
  "/ocean-guide/after-typhoon-sea",
]);
